/* Feetee CRO v17 — content-visibility + scroll rendering budget */

/* ── Patch addEventListener (passive touchmove) ─────────────────────────── */
(function(){
  var _o=EventTarget.prototype.addEventListener;
  EventTarget.prototype.addEventListener=function(type,fn,opts){
    if(type==='touchmove'){
      opts=(opts&&typeof opts==='object')
        ?Object.assign({},opts,{passive:true})
        :{passive:true,capture:opts===true};
    }
    return _o.call(this,type,fn,opts);
  };
})();

(function(){

/* ── CSS fixes injected synchronously at parse time ─────────────────────── */
(function(){
  var s=document.createElement('style');
  s.textContent=[
    /* Scroll context */
    '#ft-sticky-atc{display:none!important}',
    'html{overflow-x:visible!important}',
    /* Remove unnecessary compositor layers from non-visible gallery images.
       All N images hold transition:opacity layers even when opacity:0.
       Scoping the transition to .active only frees N-1 compositor layers. */
    '.shop-main-image:not(.active){transition:none!important;will-change:auto!important}',
    /* Touch-action belt-and-suspenders */
    '.shop-product-carousel,.shop-main-image-wrapper,.shop-thumbnails-outer,.shop-product-info,.shop-add-to-cart-wrapper{touch-action:pan-y!important}',
    /* Kill zoom scroll handler */
    '.animate--zoom-in{--zoom-in-ratio:1!important}',
    /* No backdrop-filter on badge */
    '#ft-guar-badge{backdrop-filter:none!important;-webkit-backdrop-filter:none!important}',
    /* Deprecated legacy scroll hack */
    '.ft-tbl-wrap{-webkit-overflow-scrolling:auto!important}'
  ].join('');
  (document.head||document.documentElement).appendChild(s);
})();

/* ── content-visibility: auto on below-fold sections ────────────────────────
   iOS Safari renders the ENTIRE page DOM on load — all sections, all images,
   all text, even when they're far below the viewport. On a page with a full
   conversion section (BA slider + UGC + reviews + timeline + table + FAQ),
   this chews through GPU memory and leaves little budget for smooth scroll.

   content-visibility:auto tells the browser: skip layout, paint and
   compositing for this section until it's close to the viewport.
   contain-intrinsic-block-size gives it an estimated height so scroll
   position calculations stay accurate while the section is deferred.

   We skip the first two sections (product + trust ticker) since those
   are above or near the fold. Everything below gets deferred.
────────────────────────────────────────────────────────────────────────── */
(function(){
  if(typeof CSS==='undefined'||!CSS.supports||!CSS.supports('content-visibility','auto'))return;
  function apply(){
    var sections=Array.from(document.querySelectorAll('[id^="shopify-section-"]'));
    sections.slice(2).forEach(function(el){
      el.style.contentVisibility='auto';
      /* Height estimate while section is not rendered.
         Set generously — the feetee-pdp section is very tall. */
      el.style.containIntrinsicBlockSize='1400px';
    });
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',apply);
  }else{
    apply();
  }
})();

/* ── Guarantee badge on gallery image ────────────────────────────────────── */
function injectGuaranteeBadge(){
  if(document.getElementById('ft-guar-badge'))return;
  var img=document.querySelector('.shop-product-gallery img')||
          document.querySelector('[class*="product-gallery"] img')||
          document.querySelector('[class*="product-media"] img')||
          document.querySelector('.shop-product-section img');
  if(!img){setTimeout(injectGuaranteeBadge,700);return;}
  var p=img.parentElement;
  if(window.getComputedStyle(p).position==='static')p.style.position='relative';
  p.insertAdjacentHTML('beforeend',
    '<div id="ft-guar-badge" style="position:absolute;top:12px;left:12px;'+
    'width:56px;height:56px;border-radius:50%;background:#1C1C1A;color:#FAF8F5;'+
    'display:flex;flex-direction:column;align-items:center;justify-content:center;'+
    'font-family:Inter,sans-serif;font-size:9px;font-weight:700;line-height:1.25;'+
    'text-align:center;z-index:10">'+
    '<span style="font-size:13px">100</span>'+
    '<span>Day</span><span>Money</span><span>Back</span></div>'
  );
}
if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',injectGuaranteeBadge);
}else{
  injectGuaranteeBadge();
}
setTimeout(injectGuaranteeBadge,1200);

})();
